module.exports = __webpack_public_path__ + "static/media/182-grenada.45a68a59.svg";